<template>
  <div>
    <!-- Checklist -->
    <div class="card">
      <div class="card-header">
        <!-- Title -->
        <h4 class="card-header-title">
          {{ $t('Notes') }}
        </h4>
      </div>
      <div class="empty-table" v-if="notes.length === 0">
        <i class="far fa-inbox d-block"></i>
        {{ $t('There is no notes') }} !
      </div>
      <div class="card-body notes-container" v-if="notes.length > 0">
        <!-- Checklist -->
        <div class="list-group list-group-flush my-n3">
          <div v-for="(note, index) in notes" :key="note.id" class="list-group-item">
            <div class="row">
              <div class="col-auto">
                <!-- Avatar -->
                <div class="avatar avatar-sm">
                  <div
                    class="avatar-title font-size-lg bg-primary-soft rounded-circle text-primary"
                  >
                    <i class="far fa-clipboard"></i>
                  </div>
                </div>
              </div>
              <div class="col ml-n2">
                <!-- Heading -->
                <p class="small mb-0">
                  {{ note.text }}
                </p>
                <!-- Time -->
                <small class="text-muted">
                  {{ note.time }}
                </small>
                <div class="delete-note" @click="deleteNote(index)" :class="'btn-btn-success'">
                  <i class="far fa-times"></i>
                </div>
              </div>
            </div>
            <!-- / .row -->
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row align-items-center">
          <div class="col">
            <!-- Input -->
            <textarea
              class="form-control form-control-flush form-control-auto"
              data-toggle="autosize"
              rows="1"
              :placeholder="$t('Add note')"
              v-model="note.text"
            ></textarea>
          </div>
          <div class="col-auto">
            <!-- Button -->
            <button
              class="btn btn-sm"
              :class="note.text === '' ? 'btn-light' : 'btn-success'"
              @click="createNote"
            >
              {{ $t('Add') }}
            </button>
          </div>
        </div>
        <!-- / .row -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      notes: [],
      customerId: this.$route.params.id,
      note: {
        user_type: 1,
        user_id: this.$route.params.id,
        text: ''
      }
    }
  },
  methods: {
    async getNotes() {
      try {
        const response = await axios.get(`/notes/1/${this.customerId}`)
        this.notes = response.data.notes
      } catch (error) {
        console.error('Error fetching notes:', error)
      }
    },
    async createNote() {
      if (this.note.text.trim() !== '') {
        try {
          const response = await axios.post('/notes', this.note)
          this.notes.unshift(response.data.note)
          this.note.text = ''
        } catch (error) {
          console.error('Error creating note:', error)
        }
      }
    },
    async deleteNote(index) {
      try {
        await axios.delete(`/notes/${this.notes[index].id}`)
        this.notes.splice(index, 1)
      } catch (error) {
        console.error('Error deleting note:', error)
      }
    }
  },
  mounted() {
    this.getNotes()
  }
}
</script>
